import { render } from "./2Fa.vue?vue&type=template&id=b2d70a72&scoped=true"
import script from "./2Fa.vue?vue&type=script&lang=js"
export * from "./2Fa.vue?vue&type=script&lang=js"

import "./2Fa.vue?vue&type=style&index=0&id=b2d70a72&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d70a72"]])

export default __exports__